export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8219.a75f05ad.jpg";